/**
 * 操作日志 module / action 中文映射
 * 与 api/app/utility/operationLog.js 枚举一一对应（唯一依据：招商管理操作日志接入实施spec 第 3 节）
 */
export const MODULE_NAME_MAP = {
  customers: '客户',
  projects: '项目',
  contracts: '合同',
  customerbills: '财务记录',
  storemaps: '门店地图',
  employees: '员工',
  store: '门店'
}

export const ACTION_NAME_MAP = {
  create: '创建',
  modify: '修改',
  delete: '删除',
  remove_physical: '物理删除',
  restore: '恢复',
  rescind: '解约',
  add_income: '添加收款',
  add_refund: '添加退款',
  modify_amount: '修改金额',
  transfer: '转让',
  ownership_change: '归属变更',
  bind: '绑定项目',
  unbind: '解绑项目',
  work_transfer: '工作移交'
}

export function moduleText (module) {
  return MODULE_NAME_MAP[module] || module || ''
}

export function actionText (action) {
  return ACTION_NAME_MAP[action] || action || ''
}

// 动作 → el-tag 颜色：删除类红 / 创建恢复绿 / 涉钱蓝 / 归属变更橙 / 其余灰
export function actionTagType (action) {
  if (action === 'delete' || action === 'remove_physical') return 'danger'
  if (action === 'create' || action === 'restore') return 'success'
  if (action === 'add_income' || action === 'add_refund' || action === 'modify_amount' || action === 'modify') return ''
  if (action === 'rescind' || action === 'transfer' || action === 'ownership_change' || action === 'work_transfer') return 'warning'
  return 'info'
}
